export enum KidneyStoneTreatment {    
    MedicalIntervention = 1,
    SurgicalIntervention = 2,
    Unknown = 3
}